import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  InputRightAddon,
  Text,
} from '@chakra-ui/react'
import type { DiscountRequest, Offer, OfferDiscounts } from 'BrokerTsLib/src/dtos'
import { DiscountType, getGcpVoucherName } from 'BrokerTsLib/src/dtos'

import { useAuth } from '@/context/AuthContext'
import { Insurer } from 'BrokerTsLib/src/enums'
import type { UseFormReturn } from 'BrokerTsLib/src/rhf'
import { FormProvider } from 'BrokerTsLib/src/rhf'
import React from 'react'
import { useInsuranceParams } from '../../context/InsuranceParamsProvider'
import { InputGroup } from '../InputGroup'
import { HelperTooltip } from '../ui/HelperTooltip'
import { QuoteItemDiscountRequestForm } from './QuoteItemDiscountRequestForm'

export const QuoteItemDiscountsForm = ({
  offer,
  requestDiscountData,
  formMethods
}:
{
  offer: Offer
  requestDiscountData: DiscountRequest
  formMethods: UseFormReturn<OfferDiscounts, any, any>
}) => {

  const { user } = useAuth()
  const allowDiscountsOverLimit = user?.allowDiscountsOverLimit ?? false

  const {
    getValues,
    getFieldState,
    register
  } = formMethods

  const discounts = getValues('discounts')

  const filteredDiscounts = discounts?.map((x, i) => { return { x, i } }).filter(x => x.x.editK2) ?? []
  const anyDiscounts = filteredDiscounts.length > 0

  const { isDisabled } = useInsuranceParams()

  return (
    <FormProvider  {...formMethods}>
      <Box as="form" sx={{ height: '100%' }}>
        <Grid
          sx={{
            height: '100%',
            rowGap: 4
          }}
        >
          <Grid
            sx={{
              height: '100%',
              width: '100%',
              gridTemplateColumns: { lg: 'repeat(2, 1fr)' },
              columnGap: 8,
              rowGap: 6,
            }}
          >
            {!anyDiscounts && <Text>Žádné slevy nejsou k dispozici</Text>}

            {anyDiscounts &&
              <>
                {filteredDiscounts.map(disc => {
                  const discError = getFieldState(`discounts.${disc.i}.discount`)?.error
                  const voucherError = getFieldState(`discounts.${disc.i}.voucher`)?.error
                  const isKoopVoucher = offer.insurerId == Insurer.Kooperativa && disc.x.type == DiscountType.Voucher
                  const isColonnadeVoucher = offer.insurerId == Insurer.Colonnade && disc.x.type == DiscountType.Voucher
                  const isGcpVoucher = offer.insurerId == Insurer.GeneraliCeskaPojistovna && 
                    (disc.x.type == DiscountType.Voucher || disc.x.type == DiscountType.VoucherPov ||
                      disc.x.type == DiscountType.VoucherHav)
                  const isCppVoucher = offer.insurerId == Insurer.CPP && 
                    (disc.x.type == DiscountType.VoucherPov || disc.x.type == DiscountType.VoucherHav)
                  const voucherName = isGcpVoucher || isCppVoucher ? getGcpVoucherName(disc.x.type) : ''

                  return (
                    <React.Fragment key={disc.x.insuranceCategoryDiscountId}>

                      {!isColonnadeVoucher && !isGcpVoucher &&
                        <FormControl isInvalid={!!discError}>
                          <Flex sx={{ width: '100%', gap: 4, justifyContent: 'space-between' }}>
                            <FormLabel htmlFor={`discounts.${disc.i}.insuranceCategoryDiscountId`}>
                              {disc.x.name}&nbsp;<Text>(max. {disc.x.maxDiscount} {disc.x.unit})</Text>

                              {disc.x.description && <HelperTooltip label={disc.x.description} />}
                            </FormLabel>
                          </Flex>

                          <InputGroup
                            htmlSize={12}
                            type='text'
                            variant='outline'
                            errors={discError}
                            {...register(`discounts.${disc.i}.discount`, {
                              onChange: (e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, '')
                              }
                            })}
                            pattern="[0-9]*"
                            step={1}
                            sx={{ fontSize: 'md', fontWeight: 'bold' }}
                            isDisabled={isDisabled}
                            rightElement={<InputRightAddon>{disc.x.unit}</InputRightAddon>}
                          >
                          </InputGroup>
                        </FormControl>
                      }

                      {(isKoopVoucher || isColonnadeVoucher) &&
                        <FormControl isInvalid={!!voucherError}>
                          <Flex sx={{ width: '100%', gap: 4, justifyContent: 'space-between' }}>
                            <FormLabel>
                              Kód voucheru
                            </FormLabel>
                          </Flex>

                          <InputGroup
                            variant='outline'
                            {...register(`discounts.${disc.i}.voucher`)}
                            errors={voucherError}
                            //id={`disc_${disc.insuranceCategoryDiscountId}_voucher`}
                            sx={{ fontSize: 'md', fontWeight: 'bold' }}
                            isDisabled={isDisabled}
                          >
                          </InputGroup>
                        </FormControl>
                      }

                      {isGcpVoucher || isCppVoucher &&
                        <FormControl isInvalid={!!voucherError}>
                          <Flex sx={{ width: '100%', gap: 4, justifyContent: 'space-between' }}>
                            <FormLabel>
                              {voucherName}
                            </FormLabel>
                          </Flex>

                          <InputGroup
                            variant='outline'
                            {...register(`discounts.${disc.i}.voucher`)}
                            errors={voucherError}                            
                            sx={{ fontSize: 'md', fontWeight: 'bold' }}
                            isDisabled={isDisabled}
                          >
                          </InputGroup>
                        </FormControl>
                      }

                    </React.Fragment>
                  )
                })}
              </>
            }

          </Grid>

          {allowDiscountsOverLimit &&
            <QuoteItemDiscountRequestForm offerId={offer.offerId} requestData={requestDiscountData} />
          }

        </Grid>
      </Box>
    </FormProvider>
  )
}

